'use client';
import Image from'next/image';
import { useTranslations } from '../utils/translations';

export default function IntroductionSection() {
  const { t } = useTranslations();
  
  return (
    <section className="w-full bg-[var(--bg-main)] py-4 sm:py-6 md:py-8 lg:py-[10px] -mt-1">
      <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Column */}
        <div className="flex flex-col justify-start items-center w-full gap-4 sm:gap-6 md:gap-8 lg:gap-[30px]">
          
          {/* Decorative Divider */}
          <div className="flex flex-row justify-center items-center w-full px-2 sm:px-4 md:px-8 lg:px-14">
            <Image
              src="/images/img_vector_purple_500.svg"
              alt={t('home.introduction.accessibility.divider_alt')}
              width={880}
              height={58}
              className="w-[90%] sm:w-[90%] md:w-[90%] lg:w-[90%] h-auto max-w-[880px] max-h-[58px] object-contain"
            />
          </div>
          
          {/* Introduction Text */}
          <p className="text-center text-[var(--text-primary)] font-inter font-medium text-[18px] sm:text-[18px] md:text-[20px] lg:text-[24px] leading-[24px] sm:leading-[24px] md:leading-[30px] lg:leading-[34px] w-full max-w-6xl px-4 sm:px-6 break-words overflow-wrap-anywhere">
            {t('home.introduction.text')}
          </p>
        </div>
      </div>
    </section>
  )
}